import { render, staticRenderFns } from "./editor-wrap.vue?vue&type=template&id=963a4fda&scoped=true&"
import script from "./editor-wrap.vue?vue&type=script&lang=js&"
export * from "./editor-wrap.vue?vue&type=script&lang=js&"
import style0 from "./editor-wrap.vue?vue&type=style&index=0&id=963a4fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963a4fda",
  null
  
)

export default component.exports